import React from 'react';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import API from "../../Services/BaseService";
import { useHistory, useLocation, useParams } from "react-router-dom";
import CommonPopup from '../../Component/CommonPopup/CommonPopup';
import checkImg from '../../assets/img/check.svg';
import errorImg from '../../assets/img/erroricon.png';
import "../../Component/CommonPopup/commonPopup.css"
import { useEffect } from 'react';
import ErrorPopup from '../FallBackUI/ErrorPopup';
import Loading from '../../Component/Loading/Loading';
import { Button } from 'antd';
import { Modal } from 'react-bootstrap';


const SealedCounterBid = (props) => {
  console.log("Counter timehb", props)
  console.log("Counter timest", props.sellitNow)
  console.log("Counter sellitNow validationcb ", props.countBid);


  const sellerData = useSelector(state => state.LoginReducer.payload);
  const [historyDetails, setHistoryDetails] = useState([]);
  const [loading, setLoading] = useState(true);
  const [bidLists, setBidLists] = useState("");
  const [flag, setFlag] = useState(false);

  const [errors, setErrors] = useState("");
  const [errorFlag, setErrorFlag] = useState(false);

  const [selectedBuyerId, setSelectedBuyerId] = useState([]);
  const [selectedDealerId, setSelectedDealerId] = useState([]);

  const [counter, setCounter] = useState();
  const [errorcounter, setErrorCounter] = useState("");
  const [alertmessage, setAlertMessage] = useState("");
  const [alerttitle, setAlertTitle] = useState("");
  const [alertimg, setAlertImg] = useState("");
  const [confirmationFlag, setConfirmationFlag] = useState(false)
  const [toggleAcceptPopupOpen, setToggleAcceptPopupOpen] = useState(true);
  const [counterBidFlag, setCounterBidFlag] = useState(false);
  const [selectAllCar, setSelectAllCar] = useState(false);
  const [bidDetail, setBidDetail] = useState("");
  const [bid, setBid] = useState("");
  const [carmaxprice, setCarmaxprize] = useState("");

  const [isCheckboxDisabled, setIsCheckboxDisabled] = useState(false);

  // const handleButtonClick = () => {
  //   setIsCheckboxDisabled(true);
  // };
  const getbidsList = (data) => {

    let request = {
      car_id: props?.carId,
      seller_id: sellerData.seller_id,
      seller_token: sellerData.seller_token,
    }
    API.post("sealedbidinfo/condition", request).then(response => {
      if (response.data.success === true) {
        setBidLists(response.data.data.map(data => { return { ...data, isChecked: false } }));
        setBid(response.data.data1[0].bid)
        setCarmaxprize(response.data.data[0].carmaxprice)
        console.log("setBidLists", response.data.data.map(data => { return { ...data, isChecked: false } }));
        // setBidDetail(response.data.data.map(data => { return { ...data, isChecked: true } }))
        setLoading(false);
      }

      else {
        setErrors(response.data.error.name)
        setErrorFlag(true)

      }


    })
      .catch(function (error) {
        if (error.response) {
          setErrors(error.response.data.error)
          setErrorFlag(true)
          setLoading(false);

        }
      });
  }


  useEffect(() => {
    getbidsList();
  }, []);


  const allCounterBid = () => {

    if (selectAllCar) {
      setSelectedBuyerId([])
      setSelectedDealerId([])
      setBidLists(bidLists.map(data => { return { ...data, isChecked: false } }))
      console.log("IF check the coming isChecked", bidLists.map(data => { return { ...data, isChecked: false } }));
      setCounterBidFlag(false)
    }
    else {
      setSelectedBuyerId(bidLists.map(data => data.buyer_id))
      setSelectedDealerId(bidLists.map(data => data.buyer_dealer_id))
      setBidLists(bidLists.map(data => { return { ...data, isChecked: true } }))
      console.log("ELSE check the coming isChecked", bidLists.map(data => { return { ...data, isChecked: true } }));
      setCounterBidFlag(true)
    }

    setSelectAllCar(!selectAllCar)
  }

  const allSelectedCounterBid = (index, buyerId, buyerDealerId) => {

    const dealerId = buyerDealerId
    const idBuyer = buyerId
    let newdata = selectedDealerId || []
    let buyerData = selectedBuyerId || []
    const localSelectDealerId = buyerDealerId
    console.log("check the new data", dealerId);
    // newdata.includes(data) ? newdata = newdata.filter(item => item !== data) :newdata.push(data)
    // setMySelectedCarId(newdata)
    if (buyerData.includes(idBuyer)) {
      newdata = newdata.filter(item => item !== dealerId)
      buyerData = buyerData.filter(item => item !== idBuyer)
      const localSelectDealerId = buyerData
      console.log("check the new data00000000", buyerData);
      setSelectedDealerId(newdata || [])
      setSelectedBuyerId(buyerData || [])
      !buyerData.length && setCounterBidFlag(false)

    }
    else {
      // newdata.push(data)             
      newdata = [...newdata, dealerId]
      buyerData = [...buyerData, idBuyer]
      console.log("check the else condition", buyerData);
      setSelectedDealerId(newdata)
      setSelectedBuyerId(buyerData)
      setCounterBidFlag(true)
    }
    bidLists.length === buyerData.length ? setSelectAllCar(true) : setSelectAllCar(false)
    console.log("====value.buyerData====", buyerData)

    const highAmt = Math.max(...bidLists
      .filter(data => buyerData.includes(data.buyer_id))
      .map(data => data.bid)
    );

    setBid(highAmt)


    console.log("====value.highAmt====", highAmt)


    setBidLists(bidLists.map(data => {
      if (data.buyer_id == idBuyer) {
        console.log("====value.isChecked====", data.isChecked, dealerId)
        data.isChecked = !data.isChecked
      }
      return data
    }

    ))
  }
  // console.log("sellitNow validationcb ", props.countBid);
  console.log("Counter highbid validation ", props.newBid, counter, bid, props.highBid);


  const Counterok = (index) => {
    setErrorCounter("")

    if (props.time == null || props.time == 0) {
      if (!counter) {
        setErrorCounter("Counter Bid is required")
        return;
      }
      else if (counter <= bid) {
        // console.log("highbid validation ", props.bid);
        setErrorCounter("Counter Bid cannot be less than or equal to high bid")
        return;
      } else if (props.sellitNow > 0 && counter >= props.sellitNow) {
        setErrorCounter("Counter Bid cannot be greater than or equal to sell it Now price")
        return;
      }
    }
    else {
      if (!props.newBid) {
        setErrorCounter("Counter Bid is required")
        return;
      }
      else if (counter <= bid) {
        setErrorCounter("Counter Bid cannot be less than or equal to high bid")
        return;
      }
      else if (flag === false) {
        if (props.newBid <= bid) {
          setErrorCounter("Counter Bid cannot be less than or equal to high bid")
          return;
        }
      }
      //   if (counter >= bid){
      //     setIsCheckboxDisabled(true);
      //     return;
      // }

      // else if (counter >= props.countBid) {
      //   setErrorCounter("Counter Bid cannot be greater than or equal to " + " " + props.countBid)
      //   return;
      // }
    }
    if (!isCheckboxDisabled) {
      setIsCheckboxDisabled(true)
      setConfirmationFlag(true)
      return
    }


    let request = {
      car_id: props?.carId,
      seller_dealer_id: sellerData.seller_dealer_id,
      counter_bid: counter ? counter : props.newBid,
      updatedBy: sellerData.seller_id,
      createdBy: sellerData.seller_id,
      seller_id: sellerData.seller_id,
      seller_token: sellerData.seller_token,
      car_max_price: props.sellitNow,
      type: "SealedBid",
      buyer_id: selectedBuyerId,
      buyer_dealer_id: selectedDealerId

    }
    console.log("counterBid : ", request);
    // return;
    API.post("Sealedcounterbid/add", request).then(response => {
      console.log("counter response======", response.data.data)
      if (response.data.success) {
        console.log("registration response=>", response)
        setToggleAcceptPopupOpen(false);
        setAlertImg(checkImg);
        setAlertTitle("Counter Bid Successfully Given")
        setAlertMessage("Thank you so much for your business.")
        props.counterBitUpdateFlag(true)
        props.handleCounter()
      } else {
        const { data } = response;
        setToggleAcceptPopupOpen(false);
        setAlertImg(errorImg);
        setAlertMessage(data.error.err)
      }
    })
      .catch(function (error) {
        if (error.response) {
          setErrors(error.response.data.error)
          setErrorFlag(true)
        }
      });
  }


  const numberPattern = (e) => {
    const value = e.target.value.replace(/\D/g, "");
    setCounter(value);
    setFlag(true)
  };

  return (

    <div>
      {toggleAcceptPopupOpen ?
        <>

          {loading ? (
            <Modal show={true} onHide={props.toggle} centered>
              <Modal.Body>
                <Loading />
              </Modal.Body>
            </Modal>
          ) :


            <>
              {errorFlag === true ? <ErrorPopup error={errors} /> :
                <>



                  <Modal show={true} onHide={props.toggle} centered>
                    <Modal.Header className='Terms-login'>
                      <h2 >Buyer Bids </h2>
                    </Modal.Header>
                    <Modal.Body>


                      <div class="table-responsive buyer-bids">

                        <table className="buyerbids">
                          <thead>
                            <tr>
                              <th className="">Buyer #</th>
                              <th className="">Dealer Name</th>
                              <th className="">Buyer Name</th>
                              <th className="">Amount</th>
                              <th className="bidscheckbox">
                                <div className="custom_checkbox">
                                  <input type="checkbox" disabled={isCheckboxDisabled ? true : false} id="selectAll" checked={selectAllCar} onChange={() => allCounterBid()} />
                                  <label for="selectAll"><span className='labl-cbs'>Counter Bid</span></label>
                                </div>
                              </th>
                            </tr>
                          </thead>
                          {bidLists.length > 0 ? bidLists.map((item, index) =>
                            <tr>
                              <td>{item.buyer_id}</td>
                              <td>{item.dealer_name}</td>
                              <td>{item.buyername}</td>
                              <td>{item.bid}</td>
                              <td>
                                <div className="custom_checkbox">
                                  <input type="checkbox" id={`SelectedCounterBid${index}`} checked={item.isChecked} onChange={(e) => allSelectedCounterBid(`SelectedCounterBid${index}`, item.buyer_id, item.buyer_dealer_id)} disabled={isCheckboxDisabled ? true : false} />
                                  <label for={`SelectedCounterBid${index}`}></label>
                                </div>
                              </td>
                            </tr>
                          ) :
                            <tr><td colspan="6" ng-show="0">
                              <b>There's No Data</b>
                            </td>
                            </tr>
                          }

                        </table>

                      </div>
                      <div class="Sellernotes">
                        <button className="cta-btns" onClick={props.toggle}>Close</button>
                      </div>



                    </Modal.Body>
                  </Modal>

                  {counterBidFlag == false ?

                    <></> :

                    <>
                      <Modal show={true} onHide={props.toggle} centered>
                        <Modal.Header className='Terms-login'>
                          <Modal.Title>Counter Bid</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <div className="modalcontent">

                            <div className="modalbody">
                              <h2 className="title"> Counter Bid</h2>
                              {!confirmationFlag ?
                                <div>
                                  <div class="col-md-12">
                                    <input className="textbox curSymbol" type="text" placeholder="" value="$" name="$" />
                                    {props.time == null || props.time == 0 ?
                                      <input className="textbox cunBid" type="text" placeholder="Enter Your Counter Bid" value={counter} onChange={numberPattern} /> :
                                      <input className="textbox cunBid" type="text" placeholder="Enter Your Counter Bid" defaultValue={props.newBid} onChange={numberPattern} />}
                                  </div>
                                  <p className="form-input-error" >{errorcounter}</p>
                                  <div class="col-md-12 btns">
                                    <button className="cta-btns" onClick={props.toggle}>Cancel</button>
                                    <button className="cta-btns" onClick={() => Counterok()} >ok</button>
                                  </div>
                                </div> :
                                <div>
                                  <div class="col-md-12">
                                    <p className=""> Are you sure to submit the counter Bid <b> {counter} </b> </p>
                                  </div>

                                  <div class="col-md-12 btns">
                                    <button className="cta-btns" onClick={() => { setConfirmationFlag(false); props.toggle() }}>Cancel</button>
                                    <button className="cta-btns" onClick={() => Counterok()}>confirm</button>
                                  </div>
                                </div>
                              }

                            </div>
                          </div>

                        </Modal.Body>
                      </Modal>

                    </>

                  }





                </>
              }</>

          }
        </>


        :
        <Modal show={true} onHide={props.toggle} centered>
          <Modal.Header className='Terms-login'>
            <h2 > {alerttitle} </h2>
          </Modal.Header>
          <Modal.Body>
            <div className="Commonfull-icon">
              <img alt="" className={alertimg === checkImg ? "successImg " : "errorImg"} src={alertimg}></img>
            </div>
            <div class="col-md-12">
              <div>
                <p className="text-center">{alertmessage}</p>
              </div>

              <div class="Sellernotes">
                <button className="cta-btns" onClick={props.toggle}>ok</button>
              </div>
            </div>

          </Modal.Body>
        </Modal>


      }




    </div>
  )
}

export default SealedCounterBid;